import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { Observable, shareReplay } from 'rxjs';
import * as m from 'moment';
import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';
import { BazisSharedModule } from '@bazis/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { DefaultLoaderComponent } from '@bazis/shared/components/loaders/default-loader.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormModule } from '@app/form/form.module';
const moment = m;

@Component({
    selector: 'app-crypto-certificates',
    templateUrl: './certificates.component.html',
    imports: [
        BazisSharedModule,
        CommonModule,
        TranslocoModule,
        DefaultLoaderComponent,
        FormsModule,
        FormModule,
        ReactiveFormsModule,
    ],
})
export class CryptoCertificatesComponent implements OnInit {
    @Input()
    certificates$: Observable<any>;

    @Input()
    certificate: any;

    @Output()
    certificateChange = new EventEmitter();

    list$: Observable<any>;

    public nowDate = new Date().toString();

    certificateControl = new FormControl();

    constructor() {}

    ngOnInit() {
        this.list$ = this.certificates$.pipe(
            map((certificates) => {
                return certificates?.map
                    ? certificates.map((certificateItem) => {
                          const valueMap = {};
                          certificateItem.value.split(', ').forEach((pare) => {
                              const arr = pare.split('=');
                              valueMap[arr[0]] = arr[1];
                          });
                          return {
                              ...certificateItem,
                              id: certificateItem.certificate?.objid,
                              valueMap,
                              disabled: moment(this.nowDate).isAfter(certificateItem.toDate),
                          };
                      })
                    : [];
            }),
            catchError((err) => {
                return err;
            }),
            shareReplay(SHARE_REPLAY_SETTINGS),
        );
    }

    select(certificate) {
        this.certificateChange.emit(certificate);
    }

    preventDefault(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
}
